
    import Vue from 'vue'
    import { home } from '../config/home'
    import router from "../router";
    import ReziseSensor from "css-element-queries/src/ResizeSensor";
    import VuePlotly from '@statnett/vue-plotly'

    export default Vue.extend({
        name: 'Research',
        metaInfo: {
            title: 'QDRA',
            meta : [
                {
                    name: 'description',
                    content : 'Thunderstorms and Cyclones are a part of life in Australia. The Queensland Disaster Research Alliance (QDRA) is a state-based University collaboration that aims to grow and integrate Queensland’s capability and capacity to deliver high impact and at-scale disaster management research outcomes for the state, nationally and internationally.'
                },
                {
                    name: 'keywords',
                    content : 'cyclones, thunderstorms, disasters, floods, fires, Australia, Queensland, houses, storm preparation, cyclone, weather, storm, protection, collaboration, disaster management, research, education'
                }
            ]
        },

        data: () => ({
            features: [
                {
                    src: 'banner.jpg',
                    icon: 'mdi-home-alert',
                    title: 'Vulnerability of Housing to Windstorms',
                    subtitle: '',
                    text: 'The Cyclone Testing Station continues to work with other industry groups to assess the vulnerability of houses in cyclonic and non-cyclonic parts of Australia. Existing houses and houses under construction have been surveyed. Full scale houses and components have been tested and analysed. Using wind tunnel tests based on scale models and full scale wind load data, vulnerability models that estimate damage to a range of house types are being produced. These models incorporate engineering theory and reliability analysis of housing performance. They are validated from post windstorm damage investigations. The outcomes from these studies are being expanded to align with the work at the National Climate Change Adaptation Research Facility.',
                    link: 'blah',
                    highlight: false,
                    elevation: 0,
                    color: "green darken-1"
                },
                {
                    icon: 'mdi-weather-hurricane',
                    src: 'damage.jpg',
                    title: 'Post Disaster Damage Investigations',
                    subtitle: '',
                    text: 'For over 30 years, the Cyclone Testing Station has been at the forefront of damage investigations after cyclones and other severe wind events. The aim of these investigations has been to understand what building products and systems performed well, as well as identifying areas for improvement in building regulations and standards. The Station has conducted these damage investigations in Queensland, Northern Territory, Western Australia and New South Wales, as well as Tonga, Vietnam, and USA. Findings from these investigations help to improve building materials and standards to minimise further loss and suffering.',
                    link: 'blah',
                    highlight: true,
                    elevation: 0,
                    color: "green darken-1"
                },

                {
                    src: 'debris.jpg',
                    icon: 'mdi-weather-dust',
                    title: 'Wind Driven Debris',
                    subtitle: '',
                    text: 'During tropical cyclones, loose objects can become airborne and cause major damage to buildings and structures by impacting windward walls. Further damage can arise from internal pressurisation of the building and water ingress. Research is undertaken by the Cyclone Testing Station engineers to study the flight initiation of potential missiles and how they might damage common building materials such as windows and wall cladding.',
                    link: '/blah',
                    highlight: true,
                    elevation: 0,
                    color: "green darken-1"
                },


                {
                    src: 'wind-driven-rain.jpg',
                    icon: 'mdi-home-roof',
                    title: 'Fatigue of Cladding',
                    subtitle: '',
                    text: 'The Cyclone Testing Station investigates the performance of roof and wall cladding systems subjected to cyclic loading, as occurs during a tropical cyclone or during repeated thunderstorms. Research has shown that even different profiles of roofing will perform differently when subjected to the same  loading sequence.',
                    link: '/blah',
                    highlight: true,
                    elevation: 0,
                    color: "green darken-1"
                },

                {
                    src: 'windbornedebris.jpg',
                    icon: 'mdi-shield-home',
                    title: 'Full Scale House Testing',
                    subtitle: '',
                    text: '<p>The Cyclone Testing Station has tested nine full scale structures ranging from a 1940\'s timber house to a split level brick house and a prefabricated kit home. While a house frame is functional and easy to build, it is very complex to analyse. The whole system is highly indeterminate with members supporting each other and sharing loads where necessary. As well as the classical structural members contributing to the strength of a house, testing has shown that cladding elements can contribute significantly to the overall strength. This is especially so in resisting lateral forces that can occur from wind or earthquake loading. However even laboratory testing of large elements such as bracing walls does not take into account the interaction of these elements with other parts of the building.</p>' +
                    '\n' +
                    '<p>The need to further understand this complex structural system has led to the Station\'s house testing research programme. This research involves the construction of full size houses then testing them to measure their response to simulated wind forces. Depending on the design of the building these forces are applied to simulate the passage of a four hour tropical cyclone or the effect of peak gusts associated with a thunder storm.</p>' +
                    '\n' +
                    '<p>From the results of testing full size houses rather than components we can determine not only the overall strength, stiffness and resilience of the structure, but discover the weak links of the load paths, that is the path the applied loads take through the structure to get to the foundations. Also we can discover how the different elements interact via load sharing where stiffer non-structural members, such as internal wall linings, attract some of the applied load away from more flexible members.</p>',
                    link: '/blah',
                    highlight: true,
                    elevation: 0,
                    color: "green darken-1"
                },




                {
                    src: 'wind-tunnel.png',
                    icon: 'mdi-turbine',
                    title: 'Boundary Layer Wind Tunnel',
                    subtitle: '',
                    text: '<p>The Cyclone Testing Station operates a 2.5m x 2.0m x 22m long Boundary Layer Wind Tunnel to conduct research in the field of wind effects on building structures. These research outcomes find many practical applications by being incorporated in wind loading standards such as AS/NZS 1170.2 AS/NZS 4650, and building codes of practice. Spatial and temporal characteristics of wind pressures acting on various types of structures (such as canopy roofs, houses, industrial sheds and stadiums) and their response to these fluctuating pressures are being studied.</p>' +
                    '\n' +
                    '<p>Variations in internal pressure with varying envelope porosity and its interaction with the external pressure distributions are also analysed in determining the net wind loads on cladding and the primary structure. Other research areas of interest include the use of pressure distribution for estimating the natural ventilation potential in houses, and the study of wind flow patterns over complex topographical features which may be used in determining a site\'s wind energy potential.</p>',
                    link: 'blah',
                    highlight: false,
                    elevation: 0,
                    color: "green darken-1"
                },

                /*{
                    icon: 'mdi-home-roof',
                    title: 'LEVEL 4',
                    subtitle: 'Roof and Wall Tie-Down Retrofit',
                    text: 'Coming Up Soon.',
                    link: 'todo',
                    highlight: false
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Select a Level of Retrofitting',
                    text: 'Some retrofitting tasks should be performed before others.',
                    link: 'select/levels'
                },
                {
                    icon: 'mdi-home',
                    title: 'Select Your House-Type to get Customised Retrofit Details',
                    text: 'Select the category your house falls in. This will help you decide which retrofits are suitable.',
                    link: 'select'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },*/
                /*,
                 {
                     icon: 'mdi-weather-windy',
                     title: 'Understand Wind Loads and House Structures',
                     text: 'Understand the relationship between wind loads and house structures.',
                     link: 'select/wind'
                 },
                 {
                     icon: 'mdi-ruler-square',
                     title: 'Understand the Principles of Retrofitting',
                     text: 'In order to protect your house you must understand the basics.',
                     link: 'select/principles'
                 }*/
            ],

        }),
        computed: {

        },
    })
